$(document).ready(function () {
  "use strict";

  $(window).scroll(function () {
    var headerHight = $(".main-header").height();

    if ($(window).scrollTop() > headerHight + 150) {
      $(".main-nav-container").addClass("sticky-navbar");
    } else {
      $(".main-nav-container").removeClass("sticky-navbar");
    }
  });

  var menuItems = $("#main-menu").html();
  var mobileMenu = $(".mobile-menu-inner");
  mobileMenu.html(menuItems);

  $("#mobile-menu-toggle").click(function () {
    $(".mobile-menu-container").addClass("active");
  });

  $(".close-mobile-menu").click(function () {
    $(".mobile-menu-container").removeClass("active");
  });

  $(".mobile-menu-inner").on("click", ".inner-menu-toggle", function () {
    $(this).parent().children(".inner-menu-list").slideToggle();
    $(this).toggleClass("active");
  });

  $(".search-toggle-btn").click(function () {
    $(".search-bar-box").toggleClass("active");
    $(".search-toggle-btn i").toggleClass("!hidden");
  });

  $(".faq-btn").click(function () {
    $(this).toggleClass("active");
  });

  $("#faq-group-1 .item-btn").click(function () {
    var value = $(this).val();
    console.log(value);

    if ($(this).hasClass("active")) {
      return;
    }

    $("#faq-group-1 .item-btn").not(this).removeClass("active");

    $(this).toggleClass("active");

    $("#faq-group-1 .item-content").each(function () {
      if (value == $(this).attr("id")) {
        $("#faq-group-1 .item-content.active").not(this).slideToggle("medium");
        $("#faq-group-1 .item-content").not(this).removeClass("active");
        $(this).slideToggle("medium");
        $(this).toggleClass("active");
      }
    });
  });

  $(".bundles-slider").owlCarousel({
    loop: true,
    nav: true,
    autoplay: true,
    autoplayTimeout: 5000,
    item: 4,
    margin: 30,
    dots: false,
    center: true,
    navContainer: ".bundles-nav",
    navText: [$(".bundles-nav .prev-slide"), $(".bundles-nav .next-slide")],
    responsive: {
      0: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1023: {
        items: 2,
      },

      1400: {
        items: 3,
      },
      1600: {
        items: 4,
      },
    },
  });

  $(".home-products-slider").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 4000,
    item: 3,
    margin: 20,
    // navContainer: '.homeTest-nav',
    navText: [
      '<i class="fa-solid fa-chevron-left text-3xl text-primary-green transition-all duration-300 ease-in-out hover:text-primary-dark"></i>',
      '<i class="fa-solid fa-chevron-right text-3xl text-primary-green transition-all duration-300 ease-in-out hover:text-primary-dark"></i>',
    ],
    responsive: {
      0: {
        items: 1,
        nav: true,
        dots: false,
      },
      639: {
        items: 2,
        center: false,
        nav: true,
        dots: false,
        dotsEach: true,
      },
      1023: {
        items: 1,
      },
      1279: {
        items: 2,
        center: false,
      },
      1535: {
        items: 3,
      },
      1920: {
        items: 3,
      },
    },
  });

  $(".insta-slider").owlCarousel({
    loop: true,
    nav: false,
    autoplay: false,
    autoplayTimeout: 5000,
    item: 4,
    margin: 0,
    dots: false,
    center: false,
    responsive: {
      0: {
        items: 1,
      },
      700: {
        items: 2,
      },
      1023: {
        items: 2,
      },

      1400: {
        items: 3,
      },
      1600: {
        items: 5,
      },
    },
  });

  /*----- Slider-active active -----*/
  $(".product-slider").owlCarousel({
    loop: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplaySpeed: 500,
    items: 1,
    margin: 100,
    dots: true,
    dotsContainer: "#custom-dots-container",
  });

  $(".similar-products-slider").owlCarousel({
    loop: true,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 4000,
    item: 3,
    margin: 20,

    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
      },
      639: {
        items: 2,
        center: false,
        nav: false,
        dots: true,
        dotsEach: true,
      },
      1023: {
        items: 3,
      },
      1279: {
        items: 3,
        center: false,
      },
      1535: {
        items: 4,
      },
      1920: {
        items: 4,
      },
    },
  });

  var proQty = $(".pro-qty");
  $(".qty-btn").on("click", function (e) {
    e.preventDefault();
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();
    if ($button.hasClass("inc")) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 1) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }
    $button.parent().find("input").val(newVal);
  });

  AOS.init();
});

var proQty = $(".pro-qty");
$(".qty-btn").on("click", function (e) {
  e.preventDefault();
  var $button = $(this);
  var oldValue = $button.parent().find("input").val();
  if ($button.hasClass("inc")) {
    var newVal = parseFloat(oldValue) + 1;
  } else {
    // Don't allow decrementing below zero
    if (oldValue > 1) {
      var newVal = parseFloat(oldValue) - 1;
    } else {
      newVal = 1;
    }
  }
  $button.parent().find("input").val(newVal);
});

$(".gallery").owlCarousel({
  loop: true,
  nav: false,
  autoplay: true,
  autoplayTimeout: 5000,
  item: 4,
  margin: 20,
  dots: false,
  center: true,
  responsive: {
    0: {
      items: 1,
    },
    700: {
      items: 2,
    },
    1023: {
      items: 2,
    },

    1400: {
      items: 3,
    },
    1600: {
      items: 4,
    },
  },
});

$(".insta-gallery").owlCarousel({
  loop: true,
  nav: false,
  autoplay: false,
  autoplayTimeout: 5000,
  item: 4,
  margin: 0,
  dots: false,
  center: false,
  responsive: {
    0: {
      items: 1,
    },
    700: {
      items: 2,
    },
    1023: {
      items: 2,
    },

    1400: {
      items: 3,
    },
    1600: {
      items: 5,
    },
  },
});
